/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{width:100%;height:100%}.launch-page-link[_ngcontent-%COMP%]{position:fixed;cursor:pointer;right:1.35rem;top:5.25rem;font-size:1.5rem;margin-top:.25rem}.submitted-invoices-container[_ngcontent-%COMP%]{width:100%;height:100%;padding:20px}.submitted-invoices-container[_ngcontent-%COMP%]   .filter-item-content[_ngcontent-%COMP%]{display:flex;flex-direction:row;align-items:center;padding-right:20px}"];
export { styles as styles };
